(() => {
    document.querySelectorAll('[data-protocol-toggle]').forEach(btn => {
        btn.addEventListener('click', () => {
            const drawer = btn.nextElementSibling;
            const isOpen = drawer.classList.toggle('open');
            btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            btn.textContent = isOpen ? 'Hide Ingredients' : 'View Ingredients';
        });
    });
})();
